import { CircularProgress, Grid } from "@mui/material";
import { useSelector } from "react-redux";

import PendingBuyWaiting from './pendingBuyWaiting'
import PendingBuyApproved from "./pendingBuyApproved";
import PendingBuyNotApproved from "./pendingBuyNotApproved";

import { selectAllEvents, selectAllSwarms, selectVisibleBuyRequests } from "../../store/slices/swarms";
import { useEditBuyRequestMutation, useGetUserBuyRequestsQuery } from "../../services/swarmsApi";
import { useCallback } from "react";
import { BuyRequestStatus } from './../../constants/enums';
import OverTheLimitBR from "./OverTheLimitBR";

const PendingBuyRequests = ({show}) => {

  const [editBuyRequest] = useEditBuyRequestMutation();
  const { isLoading } = useGetUserBuyRequestsQuery();


  const swarms = useSelector(selectAllSwarms);
  const events = useSelector(selectAllEvents);
  const buyRequests = useSelector(selectVisibleBuyRequests);

  const activeSwarms= (swarms || []).filter(s => s?.running === true)

  const getSwarm = useCallback(
    (buyRequest) => swarms?.find(s => s?.id && s?.id === buyRequest.swarmId)
  , [swarms])

  const getEvent = useCallback((buyRequest) => {
      const swarm = getSwarm(buyRequest);
      let e = events?.find(e => e && e.bteId === swarm?.bteId);
      return e
    },
  [getSwarm, events]
  )

  const onCloseClick = useCallback(async (BR) => {
    console.log('close clicked');
    try {
      let res = await editBuyRequest({ id: BR.id, acknowledge: true }).unwrap()
    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      throw error;
    }
  },[editBuyRequest])

  const onWaitingCloseClick = async (BR) => {
    console.log('close clicked');
    try {
      let res = await editBuyRequest({ id: BR.id, swarmResolutionTypeId: BuyRequestStatus.CanceledByBee}).unwrap()
    } catch (error) {
      if (error.status == 401) return; //error managed on baseQueryWithReauth
      throw error;
    }
  }

  if (isLoading) return <CircularProgress />

  if ((!buyRequests || buyRequests?.length === 0) && !isLoading && !show ) return null
    
  return (
    <Grid sx={{ width: '100%' }} >

      <h3 style={{ margin: "0 0 0.5em 0" }}>Pending Buy Requests</h3>

      {
        !buyRequests || buyRequests?.length === 0
          ? (
            activeSwarms ? <h4 style={{ color:' var(--orange) ', fontWeight:'600' }} >There are no buying requests</h4>
            : <h4 style={{ color:' var(--orange) ', fontWeight:'600' }} >There are no Swarms active</h4>
          )
          : buyRequests?.map((buyRequest, i) => {
            switch (buyRequest?.swarmResolutionTypeId) {
              case BuyRequestStatus.Pending:
                return (
                  <PendingBuyWaiting buyRequest={buyRequest} event={getEvent(buyRequest)} swarm={getSwarm(buyRequest)} onCloseClick={onWaitingCloseClick} />
                )
              case BuyRequestStatus.Accepted:
                return (
                  <PendingBuyApproved key={buyRequest.id} buyRequest={buyRequest} event={getEvent(buyRequest)} swarm={getSwarm(buyRequest)} onCloseClick={onCloseClick} />
                )
              case BuyRequestStatus.Rejected:
                return (
                  <PendingBuyNotApproved buyRequest={buyRequest} event={getEvent(buyRequest)} swarm={getSwarm(buyRequest)} onCloseClick={onCloseClick} />
                )
              case BuyRequestStatus.OverTheLimit:
                return (
                  <OverTheLimitBR buyRequest={buyRequest} event={getEvent(buyRequest)} swarm={getSwarm(buyRequest)} onCloseClick={onCloseClick} />
                )
            }

          })}

    </Grid>
  )

}

export default PendingBuyRequests;